<div class="offer__info__wycena"
     [ngClass]="{
     'offer-car-valuation--column': columnPosition,
     'offer__info__wycena': addValuationColorStyles
     }">
  <span class="offer__info__wycena--first-raw">{{ valuationTranslation | translate}}</span>
  <span *ngIf="carValuation; else noValuation">{{ carValuation | formatAmount }} {{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}</span>
  <ng-template #noValuation>
    <span class="no-valuation">{{'OFFER_SECTION.BOX.noCarValuationValue' | translate}}</span>
  </ng-template>
</div>
